import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import AddTechnicianConsumableModal from './AddTechnicianConsumableModal';
import ViewTechnicianConsumablesModal from './ViewTechnicianConsumablesModal';
import { supabase } from '../../../lib/supabase';

const TechnicianCard = ({ technician, onEdit, onDelete, onConsumableUpdate }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const handleAddConsumable = async (consumableData) => {
    try {
      const { error } = await supabase
        ?.from('consumables_techniciens')
        ?.insert([consumableData]);
        const { data: consumable, error: updateError } = await supabase?.from('consumables')?.select('current_stock')?.eq('id', consumableData.consumable).single();
      const { error: stockError } = await supabase
  ?.from('consumables')
  ?.update({
    current_stock: consumable?.current_stock - (parseInt(consumableData.quantity) || 1)
  })
  ?.eq('id', consumableData.consumable);
      if (error || stockError) throw error || stockError;

      setShowAddModal(false);
      if (onConsumableUpdate) onConsumableUpdate();
    } catch (err) {
      console.error('Error adding consumable:', err);
      alert('Erreur lors de l\'ajout du consommable');
    }
  };

  return (
    <>
      <div className="bg-card rounded-lg border border-border p-5 hover:shadow-md transition-shadow">
        {/* ... reste du contenu de la carte ... */}
 <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              {technician?.avatar ? (
                <img 
                  src={technician.avatar} 
                  alt={technician.full_name}
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <Icon name="User" size={24} className="text-primary" />
              )}
            </div>
            <div>
              <h3 className="font-semibold text-foreground">{technician?.full_name}</h3>
              <p className="text-xs text-muted-foreground capitalize">{technician?.specialty}</p>
            </div>
          </div>
          <div className={`px-2 py-1 rounded text-xs font-medium ${
            technician?.is_active 
              ? 'bg-success/10 border-success/20 text-success' 
              : 'bg-muted border-border text-muted-foreground'
          }`}>
            {technician?.is_active ? 'Actif' : 'Inactif'}
          </div>
        </div>

        <div className="space-y-2 mb-4">
          {technician?.email && (
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Mail" size={14} className="text-muted-foreground" />
              <span className="text-foreground">{technician?.email}</span>
            </div>
          )}
          
          {technician?.phone && (
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Phone" size={14} className="text-muted-foreground" />
              <span className="text-foreground">{technician?.phone}</span>
            </div>
          )}
        </div>

        <div className="bg-muted/50 rounded-lg p-3 mb-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Rendez-vous max/jour</span>
              <span className="text-sm font-semibold text-foreground">{technician?.max_daily_appointments || 8}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Rayon d'intervention</span>
              <span className="text-sm font-semibold text-foreground">{technician?.service_radius_km || 30} km</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Note</span>
              <span className="text-sm font-semibold text-foreground">{technician?.rating || '0.0'}/5</span>
            </div>
          </div>
        </div>

        {technician?.avatar_url && (
          <p className="text-xs text-muted-foreground mb-4 line-clamp-2">{technician?.avatar_url}</p>
        )}

        {/* Actions pour les consommables */}
        <div className="grid grid-cols-2 gap-2 mb-3">
          <Button
            variant="outline"
            size="sm"
            iconName="PackagePlus"
            onClick={() => setShowAddModal(true)}
            className="w-full"
          >
            Ajouter
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Package"
            onClick={() => setShowViewModal(true)}
            className="w-full"
          >
            Stock
          </Button>
        </div>

       
      </div>

      {/* Modals */}
      <AddTechnicianConsumableModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onAdd={handleAddConsumable}
        technicianId={technician?.id}
        technicianName={technician?.full_name}
      />

      <ViewTechnicianConsumablesModal
        isOpen={showViewModal}
        onClose={() => setShowViewModal(false)}
        technicianId={technician?.id}
        technicianName={technician?.full_name}
      />
    </>
  );
};

export default TechnicianCard;